import * as Types from "../constants/actionTypes";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.SITE_INFO:
      return {
        ...state,
        ...action.payload.siteInfo,
      };
    default:
      return state;
  }
};
